const linkURL = 'https://rails-cah.herokuapp.com';
// const linkURL = 'http://localhost:3000';

export default linkURL;
